import React, { useContext, useMemo } from 'react'
import { JsonForms } from '@jsonforms/react'
import { materialCells } from '@jsonforms/material-renderers'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { themeDefault } from 'designer/component/display/themes/layoutTheme'

import { createDisplayRenderer } from 'designer/component/control/renderer'
import { DesignContext } from 'contexts/DesignContext'
import useAuth from 'hooks/useAuth'
import { getShowUiConfig } from 'designer/component/action/Config'
import {
  checkHasShow,
  checkIsShow,
} from 'designer/component/action/condition/Action'

const WidgetTemplate = ({ props }) => {
  let { data, uischema, schema } = props
  const designContext = useContext(DesignContext)
  const { jsonForm } = designContext
  const { config } = useAuth()
  const isShowUiConfig = getShowUiConfig({ uischema, config, jsonForm })
  let hasShow = checkHasShow({ designContext, uischema, config: props.config })
  let isShow = checkIsShow({ designContext, uischema, config: props.config })

  const renderers = useMemo(() => {
    return createDisplayRenderer(uischema.elements)
  }, [uischema])

  return (
    <div
      style={{
        width: '100%',
        height: '90%',
        margin: uischema.layoutMargin ?? 0,
        padding: uischema.layoutPadding ?? 0,
      }}
      hidden={hasShow ? !isShow : !isShowUiConfig}
    >
      <MuiThemeProvider theme={themeDefault}>
        <JsonForms
          config={props.config}
          schema={schema}
          uischema={uischema}
          data={data}
          renderers={renderers}
          cells={materialCells}
        />
      </MuiThemeProvider>
    </div>
  )
}

export default WidgetTemplate
